import { Middleware } from '@reduxjs/toolkit';
import { RootState } from '@/redux/store.ts';
import { authSlice, logout } from '@/features/auth/auth.slice.ts';
import { setLocalStorageItem } from '@/utils/local-storage.ts';

export const authPersistenceMiddleware: Middleware<{}, RootState> = ({ getState }) => {
  return (next) => (action) => {
    const result = next(action);
    const state = getState();
    if (
      typeof action === 'object' &&
      action !== null &&
      'type' in action &&
      typeof action.type === 'string'
    ) {
      if (action.type.startsWith(authSlice.name) && state.auth) {
        setLocalStorageItem(authSlice.name, state.auth);
      }

      if (action.type === logout.type) {
        localStorage.removeItem(authSlice.name);
      }
    }

    return result;
  };
};
